import React, { useState } from "react";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Services from "./components/Services";
import Employees from "./components/Employees";
import Careers from "./components/Careers";
import Clients from "./components/Clientes";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import CookieConsent from "react-cookie-consent";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PrivacyPolicyPopup from './components/PrivacyPolicyPopup';  // Popup de la política de privacidad

function App() {
  const [showPrivacyPopup, setShowPrivacyPopup] = useState(false);

  // Función para mostrar el popup
  const handleShowPrivacyPopup = () => {
    setShowPrivacyPopup(true);
  };

  // Función para cerrar el popup
  const handleClosePrivacyPopup = () => {
    setShowPrivacyPopup(false);
  };

  return (
    <Router>
      <div className="App">
        <Navbar />
        <main>
          {/* Utilizamos Routes y Route para el enrutamiento */}
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </main>
        <Services />
        <Employees />
        <Careers />
        <Clients />
        <Contact />
        <Footer />
        <CookieConsent
          location="bottom"
          buttonText="Aceptar"
          declineButtonText="Rechazar"
          enableDeclineButton
          onAccept={() => console.log('Cookies aceptadas')}
          onDecline={() => console.log('Cookies rechazadas')}
          cookieName="myAwesomeCookieConsent"
          style={{ background: "#d4b5dc", color: "#fff" }}
          buttonStyle={{ background: "#fff", color: "#6a0dad", fontSize: "13px", borderRadius: "20px" }}
          declineButtonStyle={{ background: "#fff", color: "#6a0dad", fontSize: "13px", marginLeft: "10px", borderRadius: "20px" }}
          expires={365}
        >
          Utilizamos cookies propias y de terceros para fines analíticos y para mostrarte publicidad personalizada en base a un perfil elaborado a partir de tus hábitos de navegación (por ej. páginas visitadas). Haz click AQUÍ para más información. Puedes aceptar las cookies pulsando el botón "Aceptar" o rechazarlas con el botón "Rechazar", consulta nuestra política de privacidad en: 
          <button onClick={handleShowPrivacyPopup} style={{ background: "none", border: "none", color: "#ffddc1", cursor: "pointer", textDecoration: "underline" }}>
            Ver política de privacidad
          </button>
          <br />
        </CookieConsent>

        {/* Mostrar el popup de política de privacidad si está activo */}
        {showPrivacyPopup && <PrivacyPolicyPopup onClose={handleClosePrivacyPopup} />}
      </div>
    </Router>
  );
}

export default App;